import { ACTIONS_YANDEX } from '../actions/yandex';

export const yandex = (state = {}, action) => {
  switch (action.type) {
    case ACTIONS_YANDEX.ADD_PRODUCTS: {
      return { ...state, ...action.data };
    }
    case ACTIONS_YANDEX.CHANGE_PRODUCT: {
      const { product } = action;

      return { ...state, byId: { ...state.byId, [product.shop_sku]: { ...product } } };
    }
    case ACTIONS_YANDEX.CHANGE_MARKET: {
      const { market } = action;
      return { ...state, market };
    }
    default:
      return state;
  }
};
